import { apiSlice } from '../../../store/api/apiSlice';

export interface ViewState {
  key: string;
  dismissed_at: string | null;
}

export const viewStateApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getViewStates: builder.query<Record<string, ViewState>, string[]>({
      query: (keys) => ({
        url: '/ui/view-states',
        method: 'GET',
        params: { keys: keys.join(',') },
      }),
      providesTags: (_result, _err, keys) =>
        keys.map((key) => ({ type: 'ViewState' as const, id: key })),
    }),
    dismissViewState: builder.mutation<ViewState, { key: string }>({
      query: (body) => ({
        url: '/ui/view-states/dismiss',
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _err, arg) => [{ type: 'ViewState' as const, id: arg.key }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetViewStatesQuery, useLazyGetViewStatesQuery, useDismissViewStateMutation } =
  viewStateApi;
